import React from 'react';
import { formatPromedio, getEstadoAcademico } from '../../utils/evaluaciones';
import './Evaluaciones.css';

// Chip con el estado académico (Aprobado / En riesgo / Sin notas) y, opcionalmente, el promedio.
const EstadoAcademicoChip = ({ estado, promedio, showPromedio = true, title }) => {
  const info = getEstadoAcademico(estado);
  return (
    <span className={`ev-estado ev-estado-${info.tone}`} title={title}>
      <i className={`fas ${info.icon}`} aria-hidden="true" />
      {info.label}
      {showPromedio && promedio !== null && promedio !== undefined && (
        <strong>{formatPromedio(promedio)}</strong>
      )}
    </span>
  );
};

export default EstadoAcademicoChip;
